"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ButtonGroup.default;
  }
});

var _ButtonGroup = _interopRequireDefault(require("./ButtonGroup"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/ButtonGroup/index.js
// module id = 497
// module chunks = 0